import { Button } from "@mui/material";
import { EMAIL_SUBJECTS, EmailTo } from "../Links/EmailTo";

const RESET = () => {
  sessionStorage.clear();
  localStorage.clear();
  window._queryClient.removeQueries();
  window.location.reload();
};

// TODO: error reporting service (Sentry, LogRocket, etc.)
export const ResetAll = ({ error }) => {
  const emailBody = `[Describe here how it happened]\n\n\n\n\n
  [Keep following section]
  message: ${error?.message}
  statusText: ${error?.statusText}
  stack: ${error?.stack}\n
  url: ${window.location.href}\n\n`;

  return (
    <div id="ResetAll" role="alert" style={{ padding: 20 }}>
      <h1>Oops!</h1>
      <p>
        Please, let us know here:{" "}
        <EmailTo subject={EMAIL_SUBJECTS.USER_ERROR_REPORT} body={emailBody} />
      </p>
      <pre style={{ color: "red" }}>{error?.statusText || error?.message}</pre>
      {!!error?.stack && <pre style={{ marginTop: 10 }}>{error?.stack}</pre>}
      <Button variant="contained" onClick={() => RESET()}>
        Log Out & Reset
      </Button>
    </div>
  );
};
